import React from "react";
import Axios from "axios";

//context api:  
//https://medium.com/datadriveninvestor/getting-started-w-reacts-context-api-f60aa9be758f

const storeContext = React.createContext();
export const Consumer = storeContext.Consumer;

export class Provider extends React.Component {
	constructor(props) {
		super(props); 
		let restType = this.getRestType(props.router.match.path);
		let route = props.router.match.path;
		let slug = props.router.match.params.slug ? props.router.match.params.slug : '';
		let timer = null;
		this.state = {
			newPage:true,
			prevSlug:null,
			slug: slug,
			coverShown:false,
			restType: restType,
			lastRestType:null,
			route: route,
			posts: [], 
			siteLoaded: false,
			pageLoaded: false,
			currentPage: 1, 
			totalPages: 0,      
			appError : '',
			frmMsg: '',
			enquireOpen: false,
			global: {
				json: 			null,
				globalFetched: 	false,
			},
			projectsMenu: {
				open: false
			},
			newsCat:'view-all',
			menu: {
				open: 			false,
				location: 		'/',
			},
			getGlobal: 			this.getGlobal.bind(this),
			toggleMenu: 		this.toggleMenu.bind(this),
			resetMenu: 			this.resetMenu.bind(this),
			toggleProjectsMenu: this.toggleMenu.bind(this),
			toggleEnquire: 		this.toggleEnquire.bind(this),
			toggleNewsCat: 		this.toggleNewsCat.bind(this),
			getHashPos: 		this.getHashPos.bind(this),
		};
	}
	
	toggleNewsCat(_cat){
		this.setState({
			newsCat: _cat
		});
	}
	
	toggleEnquire(){
		if (this.state.enquireOpen === true) {
			this.setState({enquireOpen: false});
		} else {
			this.setState({enquireOpen: true});
		}
	}
	
	getRestType (path){
		let restType = '';
		switch(path){   
			case '/':
				restType = 'front';
				break; 
			case '/news':
				restType = 'news';
				break; 
			case '/news/:slug':
				restType = 'article';
				break; 
			case '/blog/category/:slug':
				restType = 'category';
				break; 
			case '/blog/:slug':
				restType = 'post';
				break; 
			case '/agents/:slug':
				restType = 'agents';
				break; 
			case '/properties/:slug':
				restType = 'properties';
				break; 
			case '/projects/:slug':
				restType = 'projects';
				break;
			default:
				restType = 'page';
			break;
		}
		return restType;
	}

	componentDidMount(){ 
    	this.getPosts(this.buildUrl());   
	}

	componentDidUpdate(prevProps){ 
		if(prevProps.router.location.pathname.split('#')[0] !== this.props.router.location.pathname.split('#')[0]){  
			let prev = prevProps.router.location.pathname.split('#')[0];
			let current = this.props.router.location.pathname.split('#')[0];
			if (prev !== current) {
				this.setState({newPage: true});
			} else {
				this.setState({newPage: false});
			}
			
			let curProps 	= this.props.router.match; 
			let prevSlug 	= prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '';
			
			this.setState({
				currentPage: 	1, 
				lastRestType: 	this.state.restType,
				restType: 		this.getRestType(curProps.path), 
				slug: 			this.props.router.match.params.slug ? this.props.router.match.params.slug : '',
				prevSlug: 		prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '',
			},function(){
				this.getPosts(this.buildUrl()); 
			})
		} else {
			let hash = window.location.hash.replace('#', '');
			window.scroll({
				behavior: 'smooth',
				left: 0,
				top: this.getHashPos(hash)
			});
		}
	}
	
	getGlobal(url) {
		let self = this;
		let global = this.state.global;
		if (global.json === null && global.globalFetched === false) {
			global.globalFetched = true;
			self.setState({
				global : global
			});
			Axios.get(url).then((response)=>{
				global.json = response.data[0];
				global.globalFetched = true;
				self.setState({
					global : global
				});
			}); 
		}
	}
	
	toggleMenu() {

	}

	buildUrl(){
		let url = '/wp-json/castran/v1/'; 
		switch(this.state.restType){   
			case 'front': 
				url += 'front';
				break;  
			case 'news': 
				url += 'news';
				break; 
			case 'listings': 
				url += 'listings';
				break; 
			case 'projects': 
				url += 'projects/';
				url += this.state.slug
				break;
			case 'properties': 
				url += 'properties/';
				url += this.state.slug
				break;
			case 'agents': 
				url += 'agents/';
				url += this.state.slug
				break;
			case 'article': 
				url += 'article/';
				url += this.state.slug
				break;
			case 'category': 
				url += 'category/';
				url += this.state.slug
				break;
			case 'post': 
				url += 'post/';
				url += this.state.slug
				break;
			case 'page': 
				default: 
				url += 'page/';
				url += this.state.slug
				break;        
		}
		return url;
	}
	
	getHashPos(id) {
		let offset = 0;
		let blocks = document.getElementsByClassName('c-page__block');
		if (blocks.length > 0) {
			for (let i=0;i<blocks.length;i++) {
				if (blocks[i].getAttribute('data-id') === id) {
					offset = blocks[i].offsetTop - document.getElementsByClassName('c-header')[0].clientHeight
				}
			}
		}
		return offset;
	}
	
	resetMenu(){
		setTimeout(function(){
			let _els = document.getElementsByClassName('c-menu__list__item--children');
			if (_els.length > 0) {
				for (let _i=0;_i<_els.length;_i++) {
					_els[_i].classList.remove('state-sub-open');
				}
			}
		}, 825);
	}

	getPosts (url){
		
		let self = this;
		let slug = this.state.slug;
		let lastRestType = this.state.lastRestType;
		let restType = this.state.restType;
		
		document.documentElement.classList.remove('state-page-loaded');
		document.documentElement.classList.remove('state-menu-open');
		document.documentElement.classList.remove('state-projects-open');
		
		this.resetMenu();
		
		if (window.sessionStorage.getItem('cover-shown') === 'true') {
			document.documentElement.classList.add('state-cover-shown');
		}
		
		let waitSpeed = 50;
		
		if (lastRestType === restType) {
			waitSpeed = 1000;
		}
		
		setTimeout(function(){
		    Axios.get(url).then((response)=>{
				self.setState({
					posts : response.data, 
					totalPages : response.headers['x-wp-totalpages']
				},function(){   
					
					let location = window.location + '';   
					let menu = this.state.menu;
					
					menu.open = false;
					menu.location = window.location.pathname + '';
					
					let hash = window.location.hash.replace('#', '');
					let offset = this.getHashPos(hash);
					
					if (this.state.posts) {
						if (this.state.posts[0]) {
							if (this.state.posts[0].page_title) {
								document.title = this.state.posts[0].page_title;
							}
						}
					}
					
					let showLoader = false;
					
					if (this.state.show_loader) {
						if (this.state.show_loader === 'true') {
							showLoader = true;
						}
					}
											
					if (this.state.coverShown === false && window.sessionStorage.getItem('cover-shown') !== 'true' && showLoader === true) {
						
						window.sessionStorage.setItem('cover-shown', 'true');
						
						setTimeout(() => {
							this.setState({
								coverShown : true
							});
							document.documentElement.classList.add('state-page-loaded');
							setTimeout(() => {
								window.scrollTo(0,offset);
							}, 0);
						}, waitSpeed);
						
						
						setTimeout(() => {
							this.setState({
								siteLoaded:true
							});
							
							setTimeout(() => {
								window.scrollTo(0,offset);
							}, 0);
						}, 5000);
						
					} else {
						this.setState({
							coverShown : true
						});
						window.sessionStorage.setItem('cover-shown', 'true');
						document.documentElement.classList.add('state-site-loaded');
						if (this.state.siteLoaded === false) {
							this.setState({
								siteLoaded:true
							});
						}
							
						
						
						setTimeout(() => {
							document.documentElement.classList.add('state-page-loaded');
							setTimeout(() => {
								window.scrollTo(0,offset);
								
							}, 0);
							setTimeout(() => {
								document.documentElement.classList.add('state-site-loaded');
							}, 400);
						}, waitSpeed);
						
					}

				});
			}).catch(function(error){
				self.appError = 'An unexpected error occurred';
			}); 
		}, 400);
	}

	render() {
    	return (
			<storeContext.Provider value={this.state}>
				{this.props.children}
			</storeContext.Provider>
		);
	}
}